import React from "react";
import {
  EmailIcon,
  EmailShareButton,
  FacebookIcon,
  FacebookShareButton,
  TwitterIcon,
  TwitterShareButton,
  WhatsappIcon,
  WhatsappShareButton,
} from "react-share";
import { buildEventShareUrl } from "../../Home/chatEventLinks";

const SocialIcons = ({ item, Share }) => {
  const shareUrl = buildEventShareUrl(item);

  return (
    <>
      <div className="flex flex-wrap items-center justify-center gap-3">
        <FacebookShareButton url={shareUrl}>
          <FacebookIcon round size={44} />
        </FacebookShareButton>
        <WhatsappShareButton url={shareUrl}>
          <WhatsappIcon round size={44} />
        </WhatsappShareButton>
        <TwitterShareButton url={shareUrl}>
          <TwitterIcon round size={44} />
        </TwitterShareButton>
        <EmailShareButton url={shareUrl}>
          <EmailIcon round size={44} />
        </EmailShareButton>
      </div>
    </>
  );
};

export default SocialIcons;
